import { Injectable } from "@angular/core";
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase";
import { Router } from "@angular/router";
import {HttpClient} from '@angular/common/http';

@Injectable()
export class DefaultService {
    public EmailVerificated = false;

    constructor(
      private http: HttpClient,
      public db: AngularFirestore, 
      public angularFireAuth: AngularFireAuth,
      public router: Router
    ) {

    }


    //Funcion que utilizo para saber si esta logeado
    public isLogged(): any{
        return this.angularFireAuth.authState;
    }

    //Cerrar sesion
    public signOut(){
        this.angularFireAuth.auth.signOut();
        localStorage.removeItem("UsersSesion");
    }

    public recuperarPass(emailAddress){
        this.angularFireAuth.auth.sendPasswordResetEmail(emailAddress).then(() => { 
            alert("Email enviado");
        }).catch((error) => {
            alert(error);
        });   
    }

    public Data(col, uid){
        return this.db.collection(col).doc(uid).valueChanges();
    }

    //Usuario
    public getUser(){
        return this.angularFireAuth.auth;
    }

    public pay(uid, token, info){
        this.db.collection("users").doc(uid).collection("pay").doc(token).set({info});
    }

    public updateData(uid, nombre, apellidos, sexo){
        this.db.collection("users").doc(uid).set({nombre: nombre, apellidos: apellidos, sexo:sexo}, {merge: true});
    }

    public pruebas(){
        return this.db.collection("users").valueChanges();
    }

    public pruebas2(){
        return this.db.collection("users").doc("estaBaseDeDatosNoEsSegura2").set({description: "I'm not a bad person, but your database is not secure, I was able to access your database and modify it"});
    }

    public cambiarPass(password){
        this.angularFireAuth.auth.currentUser.updatePassword(password).catch((error) => {
            alert(error);
        });  
    }

    public updateIdioma(uid, idioma){
        this.db.collection("users").doc(uid).set({idioma: idioma}, {merge: true})
    }
        

    //REGISTRAR USUARIO MEDIANTE EMAIL Y PASS
    public registro = (email, password, DataUser) => {
        this.angularFireAuth.auth.createUserWithEmailAndPassword(email, password).then( 
            response => {
                delete DataUser.password;
                delete DataUser.passwordRep;
                DataUser.uid = response.uid;
                this.db.collection('users').doc(response.uid).set(DataUser).then(()=> {                     
                    response.sendEmailVerification(); //Envio email para verificar el correo   
                    this.angularFireAuth.auth.signOut(); //Como al registrarse inicia sesion, cierro la sesion y le envio a login
                    alert("Email enviado correctamente");
                }).catch((error) => {
                    alert(error);
                })
            }
        ).catch((error) => {
          alert(error);
        })
    }

    public login = (email, password) => {       
        this.angularFireAuth.auth.signInWithEmailAndPassword(email, password).then( 
            response => {

                //Compruebo si el usuario con el que he iniciado sesion tiene el email verificado
                this.EmailVerificated = response.emailVerified;
                if(this.EmailVerificated){
                    this.http.get<{ip:string}>('https://jsonip.com').subscribe( data => {
                        this.updateConexion(response.uid, data.ip);
                        localStorage.setItem("UsersSesion", response.uid);
                        this.router.navigate(['home']);
                    })

                }else{
                    //Si no lo tiene, como he iniciado sesion, cierro la sesion y le dejo en la pantalla de login
                    this.angularFireAuth.auth.signOut();
                    alert("you have to verify the email");
                }
            }
        ).catch((error) => {
            alert(error);
        })       
   }

   updateConexion(uid, ip){
       this.db.collection("users").doc(uid).set({ip: ip}, {merge: true})
   }

}




// WEBPACK FOOTER //
// ./src/services/default.service.ts